import { faCrown, faKey, faPersonRunning, IconDefinition } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const RoleColor = {
    'Gold Guild': '#eeb802',
    'Platinum Guild': '#b6dfdf',
    'Diamond Guild': '#a27ee0',
}

const Badge = ({ icon, color, title }: { icon: IconDefinition, color?: string, title?: string }) => {
    return <div 
        className="flex flex-row items-center justify-center py-1 px-2 rounded border border-black border-opacity-50 text-xs max-h-full"
        title={title}
        style={{ 
            background: color,
        }}
    >
        <FontAwesomeIcon icon={icon} color={color} className="filter brightness-50"/>
    </div>
}

export const RoleIcon = {
    'Beta Tester': <Badge icon={faKey} />,
    'Gold Guild': <Badge icon={faCrown} color={RoleColor['Gold Guild']} title='Gold Guild' />,
    'Platinum Guild': <Badge icon={faCrown} color={RoleColor['Platinum Guild']} title='Platinum Guild' />,
    'Diamond Guild': <Badge icon={faCrown} color={RoleColor['Diamond Guild']} title='Diamond Guild' />,
    'BR1 Racer': <Badge icon={faPersonRunning}/>
}

export const TopGuildRoleIcon = ({ roles }: { roles: Array<string> }) => {
    const list = ['Diamond Guild', 'Platinum Guild', 'Gold Guild']
    for (const entry of list) {
        if (roles.includes(entry))
            return RoleIcon[entry]
    }
}

export default ({ roles }: { roles: Array<string> }) => {

    return <div className="flex flex-col gap-2 p-4">
        <header className="font-bold">ROLES</header>
        {roles.map(role => <div key={role} className="flex flex-row gap-2 items-center justify-center overflow-auto rounded-lg p-2 text-center" style={{ background: 'rgba(21, 18, 24, 0.52)' }}>
            {RoleIcon[role]}
            <span>{role}</span>
        </div>)}
    </div>
}